import React, { forwardRef } from "react";
import { Row, Col } from "antd";
import CalenderItem from "../../../components/forms/CalenderItem";
import { FormattedMessage } from "react-intl";
import DayOfWeek from "../../../components/tables/DayOfWeek";
import StartHour from "../../../components/tables/StartHour";
import EndHour from "../../../components/tables/EndHour";
import Surface from "../../../components/layouts/Surface";
import FormHeader from "../../../components/forms/FormHeader";
import { ReactComponent as ChildImg } from "../../../assets/no-child-info.svg";
import { InputItem } from "../../../components/forms/FormItems";
import AnimationChildWrapper from "../../../components/animations/AnimationChildWrapper";

const Availability = forwardRef((props, ref) => {
  const { activePatient, smallSpace } = props;
  const Comp = () => (
    <div>
      <AnimationChildWrapper key={2} itemKey={2}>
        <InputItem name={"place"} category={"availability"} required={true} />
      </AnimationChildWrapper>
      <AnimationChildWrapper key={3} itemKey={32}>
        <InputItem name={"description"} category={"availability"} />
      </AnimationChildWrapper>
    </div>
  );
  return (
    <div style={{ display: "flex", flexDirection: "column" }} ref={ref}>
      <Surface smallSpace={smallSpace}>
        <FormHeader
          title={<FormattedMessage id="app.patients.availability" />}
        />
        <Row>
          <Col xs={24} sm={24} md={24} lg={24} xl={24}>
            <CalenderItem
              entityId={activePatient.id}
              comp={<Comp />}
              resource={"patients"}
              action={"editor"}
              emptyImg={<ChildImg />}
              name="non_available_hours"
              category="patient"
              title={<FormattedMessage id="app.patients.nonAvailableHours" />}
              addText={
                <FormattedMessage id="app.patients.addUnAvailableHours" />
              }
              editText={
                <FormattedMessage id="app.patients.editUnAvailableHours" />
              }
              tableItems={[
                {
                  title: "day_of_week",
                  render: DayOfWeek,
                },

                {
                  title: "start_time_minutes",
                  render: StartHour,
                },
                {
                  title: "duration_minutes",
                  render: EndHour,
                },
                {
                  title: "place",
                },
                {
                  title: "description",
                },
              ]}
            />
          </Col>
        </Row>
      </Surface>
    </div>
  );
});

export default Availability;
